const env = process.env.NODE_ENV;

const production = {
  API_BASE: '/admin',
};

const test = {
  ...production,
  ...{
    API_BASE: '/admin',
  },
};

const development = {
  ...production,
  ...test,
  ...{
  },
};


const config = {
  production,
  development,
  test,
};

export default config[env];



// WEBPACK FOOTER //
// ./src/config.js